import { Icon } from '@rbilabs/components-library/build/components/icon';
import styled from 'styled-components';

export const WarningContainer = styled.div`
  background-color: rgba(0, 0, 0, 0.04);
  padding: 1rem;
  margin-block-start: 0.5rem;
  display: flex;
`;

export const WarningText = styled.p`
  margin: 0;
  padding: 0;
  white-space: initial;
`;

export const WarningMessageContainer = styled.div`
  display: flex;
  margin-inline-start: 1rem;
  flex-direction: column;
`;

export const WarningInfoIcon = styled(Icon)``;
